<header id="page-topbar" data-scroll-header (window:scroll)="windowScroll()">
    <div class="layout-width">
        <div class="navbar-header">
            <div class="d-flex">
                <!-- LOGO -->
                <div class="navbar-brand-box horizontal-logo">
                  
                    <a href="javascript:void(0);" class="logo logo-image">
                        <span class="logo-sm">
                            <img src="assets/images/logo-sm.png" alt="" height="22">
                        </span>
                        <span class="logo-lg">
                            <img src="assets/images/clfs-logo-image.png" alt="" height="17">
                        </span>
                    </a>

                    <a href="javascript:void(0);" class="logo logo-image">
                        <span class="logo-sm">
                            <img src="assets/images/logo-sm.png" alt="" height="22">
                        </span>
                        <span class="logo-lg">
                            <img src="assets/images/clfs-logo-image.png" alt="" height="17">
                        </span>
                    </a>
                </div>

                <button type="button" 
                class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger" 
                id="topnav-hamburger-icon" (click)="toggleMobileMenu($event)">
                    <span class="hamburger-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button>

            </div>

            <div class="d-flex align-items-center">
   <!-- Semester  -->
   <div *ngIf="userData && userData.role=='Teacher'" class="ms-1 topbar-head-dropdown header-item">
    <!-- print the current active semester of this teacher (teacherActiveSemester) and Change word with link to /teacher/semesters -->
    <a href="javascript:void(0);" class="btn btn-soft-primary" [routerLink]="['/teacher/semesters']">
        <i class="bx bx-calendar fs-16 align-middle me-1"></i>
        <span class="align-middle">{{ teacherActiveSemester?.name }}</span>
    </a>
   </div>
                <div class="ms-1 header-item d-none d-sm-flex">
                    <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle" data-toggle="fullscreen" (click)="fullscreen()">
                        <i class='bx bx-fullscreen fs-22'></i>
                    </button>
                </div>

             
                <div class="dropdown ms-1 topbar-head-dropdown header-item">
                    <a *ngIf="!isArLang()" (click)="setLanguage('ar')" href="javascript:void(0);" class=" btn-soft-primary">
                        <!-- flag from issets -->
                         &nbsp;&nbsp; <img src="assets/images/ar.png" alt="عربي" height="25" class="me-1">
                          
                        </a>
                        <a *ngIf="isArLang()" (click)="setLanguage('en')" href="javascript:void(0);" class=" btn-soft-primary">
                         &nbsp;&nbsp; <img src="assets/images/en.png" alt="English" height="25" class="me-1">
                           
                        </a>
                </div>
               


                <div class="dropdown ms-sm-3 header-item topbar-user" ngbDropdown>
                    <button type="button" class="btn" id="page-header-user-dropdown padding-10" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                        <span class="d-flex align-items-center">
                          
                            <img class="rounded-circle header-profile-user" [src]="userData?.profile_photo ? userData?.profile_photo : 'assets/images/no-user-image.jpeg'" alt="Header Avatar">
                            <span class="text-start ms-xl-2">

                                <span class="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                                    {{ translate.currentLang === 'ar' ? userData?.name_ar : userData?.name_en }}
                                </span>
                                <span class="d-none d-xl-block ms-1 fs-15 text-muted user-name-sub-text">{{ 'ROLE.' + userData?.role | translate }}</span>
                            </span>
                        </span>
                    </button>
                 
                    <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                   <!-- <a class="dropdown-item" routerLink="/pages/profile">
                    <i class="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i> 
                    <span class="align-middle">Profile</span></a> -->

                    <a class="dropdown-item" [routerLink]="
                    userData?.role === 'Teacher' ? '/profile/teacher-profile' : 
                    userData?.role === 'Student' ? '/profile/student-profile' : 
                    userData?.role === 'Parent' ? '/profile/parent-profile' : 
                    userData?.role === 'InstitutionLeader' ? '/profile/institution-profile' :
                    '/profile/admin-setting'
                  ">
                    <i class="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i> 
                    <span class="align-middle">{{ 'general.settings' | translate }}</span>
                  </a>



                        <a class="dropdown-item" href="javascript: void(0);" (click)="logout()">
                            <i class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> 
                            <span class="align-middle" data-key="t-logout">{{'general.logout' | translate}}</span></a>
                  
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>

<!-- removeNotificationModal -->
<ng-template #removenotification let-modal>
    <!-- <div class="modal-dialog modal-dialog-centered"> -->
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="NotificationModalbtn-close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="mt-2 text-center">
                <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
                <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                    <h4>Are you sure ?</h4>
                    <p class="text-muted mx-4 mb-0">Are you sure you want to remove this Notification ?</p>
                </div>
            </div>
            <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modal.dismiss('Cross click')">Close</button>
                <button type="button" class="btn w-sm btn-danger" id="delete-notification" (click)="notificationDelete()">Yes, Delete It!</button>
            </div>
        </div>

    </div><!-- /.modal-content -->

</ng-template>